<template>
  <div>
    <Breadcrumbs :items="items" />

    <v-sheet class="transparent-background-color">
      <v-card class="ma-4 pa-10">
        <v-timeline align-top dense class="mx-10" v-if="alerts.length">
          <v-timeline-item
            v-for="(item, i) in alerts"
            :key="i"
            color="danger"
            small
          >
            <v-card color="topbar">
              <v-card-title class="text-subtitle-1">
                {{ item.title }}
              </v-card-title>
              <v-card-text>
                <p>
                  {{ item.content }}
                </p>
                <v-row class="pr-8 pb-2">
                  <!-- <span></span> -->
                  <v-spacer></v-spacer>
                  <v-btn
                    v-if="item.actions.redirect"
                    class="px-2 me-2 mb-1"
                    color="primary"
                    @click="$router.push(item.redirect_url)"
                    outlined
                  >
                    {{ $t("Alert.check") }}
                  </v-btn>
                  <v-btn
                    v-if="item.actions.re_push"
                    class="px-2 me-2 mb-1"
                    color="danger"
                    outlined
                    @click="rePush(item.id)"
                  >
                    {{ $t("Alert.deal") }}
                  </v-btn>
                </v-row>
              </v-card-text>
            </v-card>
          </v-timeline-item>
        </v-timeline>
        <v-timeline align-top dense class="mx-10" v-else>
          <v-timeline-item color="danger" small>
            <v-card color="topbar">
              <v-card-title class="text-subtitle-1">
                {{ $t("Alert.noAlert") }}
              </v-card-title>
            </v-card>
          </v-timeline-item>
        </v-timeline>
      </v-card>
    </v-sheet>
  </div>
</template>
<script>
import { mapState } from "vuex";
import i18n from "@/i18n";
import Breadcrumbs from "@/components/Breadcrumbs";
import Alerts from "@/api/alerts";

export default {
  components: {
    Breadcrumbs,
  },

  mounted() {
    this.getAlertsFromAPI();
  },

  computed: {
    items: () => [
      {
        text: i18n.t("SettingNav.home"),
        disabled: false,
        href: "/home",
      },
      {
        text: i18n.t("Alert.objName"),
        disabled: true,
        href: "/alerts",
      },
    ],

    // 使用对象展开运算符将此对象混入到外部对象中
    ...mapState(["loading", "accountUser"]),
  },

  data: () => ({
    alerts: [],
  }),

  methods: {
    getAlertsFromAPI() {
      Alerts.fetch({ state_flgs: [0, 1] }).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.alerts = response.data.alerts;
          }
        }.bind(this)
      );
    },
    rePush(id) {
      Alerts.rePush(id).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.getAlertsFromAPI();
          }
        }.bind(this)
      );
    },
  },

  watch: {},
};
</script>